<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-10 offset-md-10  ">
                <div class="wrapper input-group">
                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-4 col-md-4 col-xs-4 col-sm-12">
                            <label for="">Usuário</label>
                            <input type="text" id="description" class="form-control" placeholder="Ex: Usuário x"
                                v-model="advanced_search_input.user">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-4 col-sm-12">
                            <label for="">IP</label>
                            <input type="text" id="ip" class="form-control" placeholder="Ex: xxx.xxx.xxx.xxx"
                                v-model="advanced_search_input.ip_address" v-mask="['###.###.###.###']">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-4 col-sm-12">
                            <label for="">Status retorno</label>
                            <multiselect v-model="advanced_search_input.response_status" :options="status_options"
                                placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                :deselect-label="'Clique para remover'">
                                <template #noResult>
                                    Nenhum status encontrado.
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6 col-md-6 col-xs-6 col-sm-12">
                            <label for="">Logs a partir de</label>
                            <input type="date" id="from" class="form-control" v-model="advanced_search_input.from">
                        </div>
                        <div class="col-xl-6 col-md-6 col-xs-6 col-sm-12">
                            <label for="">Logs até</label>
                            <input type="date" id="to" class="form-control" v-model="advanced_search_input.to">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i>
                                Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i>
                                Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Logs registrados<br><small><span
                                    v-if="logs.length > 0">Total registros encontrados: {{ formatDecimal(logs.length) }}</span></small>
                        </h6>
                        <button class="btn btn-warning btn-sm" @click="refreshPage()"><i class="fa fa-undo"></i>
                            Recarregar
                            dados</button>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Usuário</th>
                                        <th>Método</th>
                                        <th>URL</th>
                                        <th class="text-center">Status</th>
                                        <th>IP</th>
                                        <th>Data</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(log, index) in logs" :key="log.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ log.user }} </td>
                                        <td v-if="log.method == 'GET'">Busca </td>
                                        <td v-else-if="log.method == 'POST'">Criação / Execução </td>
                                        <td v-else-if="log.method == 'PUT'">Atualização </td>
                                        <td v-else-if="log.method == 'DELETE'">Exclusão </td>
                                        <td v-else>{{ log.method }} </td>
                                        <td>{{ log.url }} </td>
                                        <td class="text-center"
                                            v-if="log.response_status >= 200 && log.response_status < 300">
                                            <span class="badge badge-success">{{ log.response_status }}</span>
                                        </td>
                                        <td class="text-center"
                                            v-else-if="log.response_status >= 400 && log.response_status < 500"><span
                                                class="badge badge-warning">{{ log.response_status }}</span> </td>
                                        <td class="text-center" v-else-if="log.response_status >= 500"><span
                                                class="badge badge-danger">{{ log.response_status }}</span> </td>
                                        <td class="text-center" v-else><span class="badge badge-info">{{
                                                log.response_status
                                                }}</span> </td>
                                        <td>{{ log.ip_address }} </td>
                                        <td>{{ log.created_at }} </td>
                                    </tr>
                                    <tr v-if="logs.length > 0 && page > 1">
                                        <td colspan="7" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="logs.length <= 0">
                                        <td colspan="7" class="text-center">Nenhum log encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Multiselect from 'vue-multiselect'
import { mask } from 'vue-the-mask'

export default {
    directives: { mask },
    components: { Loading, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {},
            logs: [],
            url_api: '',
            page: 1,
            last_page: 1,
            total_itens: 0,
            status_options: ['200', '201', '401', '404', '422', '500', '503'],
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.logs = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.logs = {}
            this.advanced_search_input = {}
            this.loadData();
        },
        refreshPage() {
            this.page = 1;
            this.loadData();
        },
        formatDecimal(number) {
           return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;

            api.get('/log', {
                params: {
                    'user': this.advanced_search_input.user,
                    'response_status': this.advanced_search_input.response_status,
                    'ip_address': this.advanced_search_input.ip_address,
                    'from': this.advanced_search_input.from,
                    'to': this.advanced_search_input.to,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.logs = response.data.data;
                    } else {
                        this.logs = this.logs.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },
    },
    mounted() {
        this.url_api = process.env.VUE_APP_URL_API
        this.loadData();

    },
}
</script>

<style></style>